import { PropsWithChildren } from 'react';

import { Button, typographyStyle, Colors } from '@revenuemarket/cds';
import { Bin } from '@revenuemarket/ui';
import { Typography } from 'antd';

interface Props extends PropsWithChildren {
  onRemove: () => void;
}

const LabelRemoveButton: React.FC<Props> = ({ onRemove }) => {
  return (
    <Button
      icon={<Bin />}
      border
      buttonType="weak"
      style={{
        width: 'fit-content',
      }}
      onClick={async () => {
        onRemove();
      }}
    >
      <Typography.Text
        style={{
          ...typographyStyle['14_400'],
          color: Colors.gray700,
        }}
      >
        삭제하기
      </Typography.Text>
    </Button>
  );
};

export default LabelRemoveButton;
